// extracted by mini-css-extract-plugin
export default {"avaDiv":"Uploader_avaDiv__gWfAD","errorAvatar":"Uploader_errorAvatar__sP9je","errorMessage":"Uploader_errorMessage__yKf0U","avaButton":"Uploader_avaButton__lhEQK"};